(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randm-collection-product-slider"] && !Shopify.designMode) return;
  try {
    
  class RandmSingleCollectionSlider extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.track = this.querySelector('[data-randm-track]');
      this.previous = this.querySelector('[data-randm-previous]');
      this.next = this.querySelector('[data-randm-next]');
      if (!this.track) return;

      this.updateButtons = () => {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = window.requestAnimationFrame(() => {
          const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const position = Math.abs(this.track.scrollLeft);
          if (this.previous) this.previous.disabled = maxScroll < 2 || position < 2;
          if (this.next) this.next.disabled = maxScroll < 2 || position > maxScroll - 2;
        });
      };

      this.previous?.addEventListener('click', () => this.move(-1), {
        signal: this.abortController.signal
      });
      this.next?.addEventListener('click', () => this.move(1), {
        signal: this.abortController.signal
      });
      this.track.addEventListener('scroll', this.updateButtons, {
        passive: true,
        signal: this.abortController.signal
      });

      this.resizeObserver = new ResizeObserver(this.updateButtons);
      this.resizeObserver.observe(this);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      window.cancelAnimationFrame(this.animationFrame);
    }

    move(direction) {
      const card = this.track.querySelector('[data-randm-product]');
      if (!card) return;
      const trackStyles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      const cardStep = card.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.floor((this.track.clientWidth + gap) / cardStep));
      const directionMultiplier = trackStyles.direction === 'rtl' ? -1 : 1;

      this.track.scrollBy({
        left: direction * directionMultiplier * cardStep * visibleCards,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  }

  if (!customElements.get('randm-single-collection-slider')) {
    customElements.define('randm-single-collection-slider', RandmSingleCollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randm-collection-showcase"]) return;
  try {
    
  class RandmCollectionProductSliders extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.updateCallbacks = [];
      this.initializeSliders();
      this.resizeObserver = new ResizeObserver(() => this.updateAll());
      this.resizeObserver.observe(this);

      this.addEventListener(
        'shopify:block:select',
        (event) => {
          const slider = event.target.closest('[data-randm-slider]');
          if (!slider || !this.contains(slider)) return;
          slider.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'center'
          });
        },
        { signal: this.abortController.signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    initializeSliders() {
      this.querySelectorAll('[data-randm-slider]').forEach((slider) => {
        const track = slider.querySelector('[data-randm-track]');
        const previous = slider.querySelector('[data-randm-previous]');
        const next = slider.querySelector('[data-randm-next]');
        if (!track) return;

        let animationFrame;
        const updateButtons = () => {
          window.cancelAnimationFrame(animationFrame);
          animationFrame = window.requestAnimationFrame(() => {
            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
            const position = Math.abs(track.scrollLeft);
            if (previous) previous.disabled = maxScroll < 2 || position < 2;
            if (next) next.disabled = maxScroll < 2 || position > maxScroll - 2;
          });
        };

        const move = (direction) => {
          const card = track.querySelector('[data-randm-product]');
          if (!card) return;
          const trackStyles = window.getComputedStyle(track);
          const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
          const cardStep = card.getBoundingClientRect().width + gap;
          const visibleCards = Math.max(1, Math.floor((track.clientWidth + gap) / cardStep));
          const directionMultiplier = trackStyles.direction === 'rtl' ? -1 : 1;

          track.scrollBy({
            left: direction * directionMultiplier * cardStep * visibleCards,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };

        previous?.addEventListener('click', () => move(-1), { signal: this.abortController.signal });
        next?.addEventListener('click', () => move(1), { signal: this.abortController.signal });
        track.addEventListener('scroll', updateButtons, {
          passive: true,
          signal: this.abortController.signal
        });

        this.updateCallbacks.push(updateButtons);
        updateButtons();
      });
    }

    updateAll() {
      this.updateCallbacks.forEach((update) => update());
    }
  }

  if (!customElements.get('randm-collection-product-sliders')) {
    customElements.define('randm-collection-product-sliders', RandmCollectionProductSliders);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randm-multi-series-product-slider"] && !Shopify.designMode) return;
  try {
    
  class RandmSeriesSlider extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.track = this.querySelector('[data-randm-track]');
      this.previous = this.querySelector('[data-randm-previous]');
      this.next = this.querySelector('[data-randm-next]');
      if (!this.track) return;

      this.updateButtons = () => {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = window.requestAnimationFrame(() => {
          const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const position = Math.abs(this.track.scrollLeft);
          if (this.previous) this.previous.disabled = maxScroll < 2 || position < 2;
          if (this.next) this.next.disabled = maxScroll < 2 || position > maxScroll - 2;
        });
      };

      this.previous?.addEventListener('click', () => this.move(-1), {
        signal: this.abortController.signal
      });
      this.next?.addEventListener('click', () => this.move(1), {
        signal: this.abortController.signal
      });
      this.track.addEventListener('scroll', this.updateButtons, {
        passive: true,
        signal: this.abortController.signal
      });

      this.resizeObserver = new ResizeObserver(this.updateButtons);
      this.resizeObserver.observe(this);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      window.cancelAnimationFrame(this.animationFrame);
    }

    move(direction) {
      const card = this.track.querySelector('[data-randm-product]');
      if (!card) return;
      const trackStyles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      const cardStep = card.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.floor((this.track.clientWidth + gap) / cardStep));
      const directionMultiplier = trackStyles.direction === 'rtl' ? -1 : 1;

      this.track.scrollBy({
        left: direction * directionMultiplier * cardStep * visibleCards,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  }

  if (!customElements.get('randm-series-slider')) {
    customElements.define('randm-series-slider', RandmSeriesSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randm-pdp-delivery-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const startOfDay = (date) => new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12));

    const toDateTime = (date) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const parseExcludedDates = (value) => new Set(
      String(value || '')
        .split(/[\s,;]+/)
        .map((date) => date.trim())
        .filter((date) => /^\d{4}-\d{2}-\d{2}$/.test(date))
    );

    const addCalendarDays = (date, days) => {
      const result = startOfDay(date);
      result.setUTCDate(result.getUTCDate() + days);
      return result;
    };

    const isSameDay = (firstDate, secondDate) => (
      firstDate.getUTCFullYear() === secondDate.getUTCFullYear()
      && firstDate.getUTCMonth() === secondDate.getUTCMonth()
      && firstDate.getUTCDate() === secondDate.getUTCDate()
    );

    const getEasterSunday = (year) => {
      const a = year % 19;
      const b = Math.floor(year / 100);
      const c = year % 100;
      const d = Math.floor(b / 4);
      const e = b % 4;
      const f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4);
      const k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(Date.UTC(year, month - 1, day, 12));
    };

    const getGermanFederalHolidays = (year) => {
      const easter = getEasterSunday(year);
      return new Set([
        `${year}-01-01`,
        toDateTime(addCalendarDays(easter, -2)),
        toDateTime(addCalendarDays(easter, 1)),
        `${year}-05-01`,
        toDateTime(addCalendarDays(easter, 39)),
        toDateTime(addCalendarDays(easter, 50)),
        `${year}-10-03`,
        `${year}-12-25`,
        `${year}-12-26`
      ]);
    };

    const isBusinessDay = (date, excludedDates, skipGermanHolidays) => {
      const weekday = date.getUTCDay();
      const dateTime = toDateTime(date);
      if (weekday === 0 || weekday === 6 || excludedDates.has(dateTime)) return false;
      if (!skipGermanHolidays) return true;
      return !getGermanFederalHolidays(date.getUTCFullYear()).has(dateTime);
    };

    const getZonedNow = (timeZone) => {
      const now = new Date();
      let formatter;

      try {
        formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23'
        });
      } catch (error) {
        formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Berlin',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23'
        });
      }

      const parts = Object.fromEntries(
        formatter.formatToParts(now).filter((part) => part.type !== 'literal').map((part) => [part.type, part.value])
      );

      return {
        date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12)),
        hours: Number(parts.hour),
        minutes: Number(parts.minute)
      };
    };

    const nextBusinessDay = (date, excludedDates, skipGermanHolidays) => {
      const next = startOfDay(date);
      do {
        next.setUTCDate(next.getUTCDate() + 1);
      } while (!isBusinessDay(next, excludedDates, skipGermanHolidays));
      return next;
    };

    const normalizeBusinessDay = (date, excludedDates, skipGermanHolidays) => {
      const normalized = startOfDay(date);
      while (!isBusinessDay(normalized, excludedDates, skipGermanHolidays)) {
        normalized.setUTCDate(normalized.getUTCDate() + 1);
      }
      return normalized;
    };

    const addBusinessDays = (date, days, excludedDates, skipGermanHolidays) => {
      const result = startOfDay(date);
      let remaining = Math.max(0, Number.parseInt(days, 10) || 0);

      while (remaining > 0) {
        result.setUTCDate(result.getUTCDate() + 1);
        if (isBusinessDay(result, excludedDates, skipGermanHolidays)) remaining -= 1;
      }

      return result;
    };

    const parseCutoff = (value) => {
      const match = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(value || '');
      if (!match) return { hours: 14, minutes: 0 };
      return { hours: Number.parseInt(match[1], 10), minutes: Number.parseInt(match[2], 10) };
    };

    const updateTimeline = (section) => {
      const timeZone = section.dataset.timezone || 'Europe/Berlin';
      const zonedNow = getZonedNow(timeZone);
      const today = zonedNow.date;
      const excludedDates = parseExcludedDates(section.dataset.excludedDates);
      const skipGermanHolidays = section.dataset.skipGermanHolidays !== 'false';
      const cutoff = parseCutoff(section.dataset.cutoff);
      const minutesNow = zonedNow.hours * 60 + zonedNow.minutes;
      const minutesCutoff = cutoff.hours * 60 + cutoff.minutes;
      let processingStart = normalizeBusinessDay(today, excludedDates, skipGermanHolidays);

      if (isBusinessDay(today, excludedDates, skipGermanHolidays) && minutesNow >= minutesCutoff) {
        processingStart = nextBusinessDay(today, excludedDates, skipGermanHolidays);
      }

      const shipped = addBusinessDays(processingStart, section.dataset.handlingDays, excludedDates, skipGermanHolidays);
      const delivered = addBusinessDays(shipped, section.dataset.deliveryDays, excludedDates, skipGermanHolidays);
      const locale = document.documentElement.lang || navigator.language || 'de-DE';
      const options = section.dataset.dateStyle === 'numeric'
        ? { day: '2-digit', month: '2-digit', timeZone: 'UTC' }
        : { day: 'numeric', month: 'long', timeZone: 'UTC' };
      const formatter = new Intl.DateTimeFormat(locale, options);
      const useTodayLabel = section.dataset.useTodayLabel !== 'false';
      const todayLabel = section.dataset.todayLabel || 'Heute';
      const dates = {
        ordered: today,
        shipped,
        delivered
      };

      section.querySelectorAll('[data-randm-date]').forEach((time) => {
        const date = dates[time.dataset.randmDate];
        if (!date) return;
        time.dateTime = toDateTime(date);
        const showToday = time.dataset.randmDate === 'ordered'
          && useTodayLabel
          && isSameDay(date, today);
        time.textContent = showToday ? todayLabel : formatter.format(date);
      });
    };

    const initialize = (root = document) => {
      root.querySelectorAll('[data-randm-delivery-timeline]').forEach((section) => {
        const mount = document.querySelector('[data-randm-delivery-mount]');
        if (mount && !mount.contains(section)) mount.appendChild(section);
        if (section.randmDeliveryInterval) window.clearInterval(section.randmDeliveryInterval);
        updateTimeline(section);
        section.randmDeliveryInterval = window.setInterval(() => updateTimeline(section), 60000);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-randm-delivery-timeline]').forEach((section) => {
        if (section.randmDeliveryInterval) window.clearInterval(section.randmDeliveryInterval);
      });
    });
    window.addEventListener('pageshow', () => initialize());
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) initialize();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randm-pdp-review-invite"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-randm-review-invite]').forEach((section) => {
        const mount = document.querySelector('[data-randm-review-invite-mount]');
        if (mount && !mount.contains(section)) mount.appendChild(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:reorder', () => initialize());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randm-pdp-series-slider"] && !Shopify.designMode) return;
  try {
    
  class RandmPdpSeriesSlider extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.track = this.querySelector('[data-series-track]');
      this.previousButton = this.querySelector('[data-series-previous]');
      this.nextButton = this.querySelector('[data-series-next]');
      if (!this.track) return;

      this.updateButtons = () => {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = window.requestAnimationFrame(() => {
          const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const currentScroll = Math.abs(this.track.scrollLeft);
          if (this.previousButton) this.previousButton.disabled = maximumScroll < 2 || currentScroll < 2;
          if (this.nextButton) this.nextButton.disabled = maximumScroll < 2 || currentScroll > maximumScroll - 2;
        });
      };

      this.previousButton?.addEventListener('click', () => this.move(-1), {
        signal: this.abortController.signal
      });
      this.nextButton?.addEventListener('click', () => this.move(1), {
        signal: this.abortController.signal
      });
      this.track.addEventListener('scroll', this.updateButtons, {
        passive: true,
        signal: this.abortController.signal
      });

      this.resizeObserver = new ResizeObserver(this.updateButtons);
      this.resizeObserver.observe(this.track);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      window.cancelAnimationFrame(this.animationFrame);
    }

    move(direction) {
      const card = this.track.querySelector('[data-series-card]');
      if (!card) return;
      const trackStyles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      const cardStep = card.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.floor((this.track.clientWidth + gap) / cardStep));
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      this.track.scrollBy({
        left: direction * cardStep * visibleCards,
        behavior
      });
    }
  }

  if (!customElements.get('randm-pdp-series-slider')) {
    customElements.define('randm-pdp-series-slider', RandmPdpSeriesSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randm-pdp-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  class RandmPdpStickyCart extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.form = this.querySelector('.randm-pdp-sticky-cart__form');
      this.variantInput = this.querySelector('[data-randm-sticky-variant]');
      this.quantityInput = this.querySelector('[data-randm-sticky-quantity]');
      this.submitButton = this.querySelector('[data-randm-sticky-submit]');
      this.buttonText = this.querySelector('[data-randm-sticky-button-text]');
      this.price = this.querySelector('[data-randm-sticky-price]');
      this.comparePrice = this.querySelector('[data-randm-sticky-compare-price]');
      this.image = this.querySelector('.randm-pdp-sticky-cart__image');
      this.nativeForm = this.findNativeForm();
      this.nativeAnchor = this.findNativeAnchor();

      try {
        this.variants = JSON.parse(this.querySelector('[data-randm-sticky-variants]')?.textContent || '[]');
      } catch (error) {
        this.variants = [];
      }

      this.queueUpdate = () => {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = window.requestAnimationFrame(() => this.updateVisibility());
      };

      this.handleVariantEvent = (event) => {
        window.setTimeout(() => this.syncVariant(event), 0);
        window.setTimeout(() => this.syncVariant(event), 80);
      };

      document.addEventListener('change', this.handleVariantEvent, {
        signal: this.abortController.signal
      });
      document.addEventListener('variant:change', this.handleVariantEvent, {
        signal: this.abortController.signal
      });
      document.addEventListener('variant:changed', this.handleVariantEvent, {
        signal: this.abortController.signal
      });
      document.addEventListener('product:variant-change', this.handleVariantEvent, {
        signal: this.abortController.signal
      });
      window.addEventListener('scroll', this.queueUpdate, {
        passive: true,
        signal: this.abortController.signal
      });
      window.addEventListener('resize', this.queueUpdate, {
        passive: true,
        signal: this.abortController.signal
      });
      this.form?.addEventListener('submit', (event) => this.handleSubmit(event), {
        signal: this.abortController.signal
      });

      if (this.nativeAnchor) {
        this.intersectionObserver = new IntersectionObserver(this.queueUpdate, {
          threshold: [0, 1]
        });
        this.intersectionObserver.observe(this.nativeAnchor);
      }

      if (this.nativeForm) {
        this.mutationObserver = new MutationObserver(this.handleVariantEvent);
        this.mutationObserver.observe(this.nativeForm, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['value', 'checked', 'selected', 'disabled']
        });
      }

      this.syncVariant();
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.intersectionObserver?.disconnect();
      this.mutationObserver?.disconnect();
      window.cancelAnimationFrame(this.animationFrame);
    }

    findNativeForm() {
      const forms = Array.from(document.querySelectorAll('#MainContent form[action*="/cart/add"]'));
      return forms.find((form) => !this.contains(form));
    }

    findNativeAnchor() {
      if (!this.nativeForm) return null;
      const button = this.nativeForm.querySelector('[name="add"], button[type="submit"]');
      return button?.closest('.product-block, [data-product-block], .product-form') || button || this.nativeForm;
    }

    handleSubmit(event) {
      event.preventDefault();
      this.syncVariant();

      if (!this.nativeForm) {
        this.nativeForm = this.findNativeForm();
      }

      const nativeSubmit = this.nativeForm?.querySelector('[name="add"], button[type="submit"]');
      const nativeVariantInput = this.nativeForm?.querySelector('[name="id"]');
      const nativeQuantityInput = this.nativeForm?.querySelector('[name="quantity"]');

      if (!this.nativeForm || !nativeSubmit || nativeSubmit.disabled || !nativeVariantInput) return;

      nativeVariantInput.value = this.variantInput?.value || nativeVariantInput.value;
      nativeVariantInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (nativeQuantityInput && this.quantityInput) {
        nativeQuantityInput.value = this.quantityInput.value || 1;
      }

      const resetButton = () => {
        this.submitButton?.removeAttribute('aria-busy');
        this.submitButton?.classList.remove('btn--loading');
      };

      this.submitButton?.setAttribute('aria-busy', 'true');
      this.submitButton?.classList.add('btn--loading');
      document.addEventListener('ajaxProduct:added', resetButton, { once: true });
      document.addEventListener('ajaxProduct:error', resetButton, { once: true });
      window.setTimeout(resetButton, 5000);

      this.nativeForm.requestSubmit(nativeSubmit);
    }

    updateVisibility() {
      if (!this.nativeAnchor) {
        this.nativeForm = this.nativeForm || this.findNativeForm();
        this.nativeAnchor = this.findNativeAnchor();
      }

      const nativeButtonPassed = Boolean(
        this.nativeAnchor && this.nativeAnchor.getBoundingClientRect().bottom <= 0
      );
      const mobileScrollFallback = Boolean(
        window.matchMedia('(max-width: 768px)').matches &&
        window.scrollY > Math.max(480, window.innerHeight * 0.75)
      );
      const shouldShow = nativeButtonPassed || mobileScrollFallback;
      this.toggleAttribute('data-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (this.submitButton) this.submitButton.tabIndex = shouldShow ? 0 : -1;
    }

    syncVariant(event) {
      if (!this.nativeForm) {
        this.nativeForm = this.findNativeForm();
        this.nativeAnchor = this.findNativeAnchor();
      }

      const detailVariant = event?.detail?.variant || event?.detail?.productVariant;
      const nativeVariantInput = this.nativeForm?.querySelector('[name="id"]');
      const urlVariantId = new URL(window.location.href).searchParams.get('variant');
      const variantId = detailVariant?.id || nativeVariantInput?.value || urlVariantId || this.variantInput?.value;
      const variant = this.variants.find((item) => String(item.id) === String(variantId));

      if (!variant || !this.variantInput) return;

      this.variantInput.value = variant.id;
      const nativeQuantity = this.nativeForm?.querySelector('[name="quantity"]');
      if (this.quantityInput) this.quantityInput.value = nativeQuantity?.value || 1;

      if (this.submitButton) this.submitButton.disabled = !variant.available;
      if (this.buttonText) {
        this.buttonText.textContent = variant.available ? this.dataset.buttonLabel : this.dataset.soldOutLabel;
      }
      if (this.price) this.price.textContent = this.formatMoney(variant.price);

      const showCompare = Number(variant.compare_at_price) > Number(variant.price);
      if (this.comparePrice) {
        this.comparePrice.hidden = !showCompare;
        if (showCompare) this.comparePrice.textContent = this.formatMoney(variant.compare_at_price);
      }

      if (this.image && variant.featured_image?.src) {
        this.image.src = variant.featured_image.src;
        this.image.srcset = '';
        this.image.alt = variant.featured_image.alt || '';
      }
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
      }

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || this.dataset.currency
        }).format(Number(cents) / 100);
      } catch (error) {
        return `${(Number(cents) / 100).toFixed(2)} ${this.dataset.currency}`;
      }
    }
  }

  if (!customElements.get('randm-pdp-sticky-cart')) {
    customElements.define('randm-pdp-sticky-cart', RandmPdpStickyCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["randm-pdp-trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const widgetSelector = '[data-randm-trustpilot-widget]';
    const sectionSelector = '[data-randm-trustpilot-section]';
    const bootstrapSelector = 'script[src*="widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]';
    const bootstrapSource = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

    const findWidgets = (root = document) => {
      const widgets = [];

      if (root instanceof Element && root.matches(widgetSelector)) {
        widgets.push(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        widgets.push(...root.querySelectorAll(widgetSelector));
      }

      return widgets;
    };

    const loadWidgets = (root = document) => {
      if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;

      findWidgets(root).forEach((widget) => {
        window.Trustpilot.loadFromElement(widget, true);
      });
    };

    const waitForTrustpilot = (resolve, reject, attempt = 0) => {
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        resolve(window.Trustpilot);
        return;
      }

      if (attempt >= 50) {
        reject(new Error('Trustpilot bootstrap did not become available.'));
        return;
      }

      window.setTimeout(() => waitForTrustpilot(resolve, reject, attempt + 1), 100);
    };

    const ensureBootstrap = () => {
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        return Promise.resolve(window.Trustpilot);
      }

      if (window.__randmTrustpilotBootstrapPromise) {
        return window.__randmTrustpilotBootstrapPromise;
      }

      window.__randmTrustpilotBootstrapPromise = new Promise((resolve, reject) => {
        let script = document.querySelector(bootstrapSelector);

        if (!script) {
          script = document.createElement('script');
          script.src = bootstrapSource;
          script.async = true;
          script.dataset.randmTrustpilotBootstrap = 'true';
          script.addEventListener('error', () => reject(new Error('Trustpilot bootstrap could not be loaded.')), { once: true });
          document.head.appendChild(script);
        }

        waitForTrustpilot(resolve, reject);
      });

      return window.__randmTrustpilotBootstrapPromise;
    };

    const boot = (root = document) => {
      if (findWidgets(root).length === 0) return;
      ensureBootstrap().then(() => loadWidgets(root)).catch(() => {});
    };

    const rootFromEditorEvent = (event) => {
      if (!(event.target instanceof Element)) return document;
      return event.target.closest(sectionSelector) || event.target;
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    } else {
      boot();
    }

    ['shopify:section:load', 'shopify:section:reorder', 'shopify:block:select'].forEach((eventName) => {
      document.addEventListener(eventName, (event) => boot(rootFromEditorEvent(event)));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
